module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_85.019ca7d3.jpg";